<ng-container *transloco="let t">
  <div class="timer">
    <div *ngIf="status === null" class="inactive">--:--</div>
    <ng-container *ngIf="status === SlotStatus.Running || status === SlotStatus.Paused">
      <ng-container *ngIf="seconds !== null">
        {{ seconds | timer }}
        <div class="timer-bars">
          <div class="base"></div>
          <div class="progress" [attr.style]="'width:' + percent + '%'"></div>
          <div class="indicator"></div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="status === SlotStatus.Finished">
      {{ t('common.labels.finished') }}
    </ng-container>
  </div>
</ng-container>
